import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	LOADING: type('[OptionsBar] loading '),
	PUT_PRICEUNIT: type('[OptionsBar] put priceUnit'),
	PUT_VIEWTOSHOW: type('[OptionsBar] put viewToShow'),
	RESET: type('[OptionsBar] reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutPriceUnit implements Action {
	type = ActionTypes.PUT_PRICEUNIT;

	/**
	 *Creates an instance of PutPriceUnit.
	 * @param {string} payload
	 * @memberof PutPriceUnit
	 */
	constructor(public payload: string) { }
}

export class PutViewToShow implements Action {
	type = ActionTypes.PUT_VIEWTOSHOW;

	/**
	 *Creates an instance of PutViewToShow.
	 * @param {string} payload
	 * @memberof PutViewToShow
	 */
	constructor(public payload: string) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions = LoadingAction | PutPriceUnit | PutViewToShow | ResetAction;
